module.exports = {"developed_by":"Solution created by the <a href=\"https://frh-fondation.ch\">FRH</a>.","how_it_works":"How it works ?","how_it_works_description":"ESAP is based on a system of reciprocal evaluation of the <b>person</b> and <b>employment</b> by confronting the intrinsic <b>abilities</b> of the person and the specific <b>requirements</b> of the job.","identity_img":"/img/identity_en.jpg","ripph_img":"/img/ripph_en.jpg"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/pages/welcome.json
// module id = WlPE
// module chunks = 20